/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SubjectAction {
    NOT_YET_ACTED = 'NOT_YET_ACTED',
    CONFIRMED_UNCHANGED = 'CONFIRMED_UNCHANGED',
    UPDATED = 'UPDATED',
    ADMIN_UPLOADED = 'ADMIN_UPLOADED',
}
